import { render, staticRenderFns } from "./GenreFilter.vue?vue&type=template&id=102aa94a&scoped=true&"
import script from "./GenreFilter.vue?vue&type=script&lang=js&"
export * from "./GenreFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102aa94a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('102aa94a')) {
      api.createRecord('102aa94a', component.options)
    } else {
      api.reload('102aa94a', component.options)
    }
    module.hot.accept("./GenreFilter.vue?vue&type=template&id=102aa94a&scoped=true&", function () {
      api.rerender('102aa94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GenreFilter.vue"
export default component.exports